<template>
  <div>
    <div v-if="!captchaOpen" class="image-wrap">
      <base-hint-input v-model.trim="captcha.value" type="tel" maxlength="4" placeholder="图片验证码" icon="reg_image" />
      <div class="captcha-img">
        <van-loading v-if="!captcha.loaded || !captcha.image" color="#56bbfb">
          加载中...
        </van-loading>
        <img v-show="captcha.loaded" :src="captcha.image" alt="" @click="getCaptcha" @load="onCaptchaLoaded">
      </div>
    </div>
    <base-hint-input v-model.trim="smscode" type="tel" maxlength="4" placeholder="手机验证码" icon="reg_captcha"
      @input="handleInput">
      <template slot="input-right">
        <base-timer-button ref="timerButton" :phone="phone" @click="handleClick" />
      </template>
    </base-hint-input>
  </div>
</template>

<style lang="less" scoped>
.image-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .rows {
    margin: 0;
  }

  .captcha-img {
    margin-left: 16px;
    width: 240px;
    height: 90px;
    text-align: center;
    padding: 18px 10px;

    img {
      display: block;
      height: 100%;
      width: 100%;
    }
  }
}
</style>

<script>
import { captchaMixin } from '../mixins/captcha-mixin';
export default {
  mixins: [captchaMixin],
  name: 'BaseSmsCaptcha',
  props: {
    value: [String, Number],
    phone: String,
    codeType: Number,
  },
  data() {
    return {
      smscode: '',
      // 图形验证码
      captcha: {
        value: '', // 前端输入的值
        code: '', // 后端校验码
        image: '', // 图片地址
        loaded: false, // 图片加载完成
        loading: false, // 加载中/刷新中
        verifying: false, // 验证中
      },
    };
  },
  computed: {
    // 正则表达式常量
    REGEX() {
      return this.$const.REGEX;
    },
  },
  watch: {},
  mounted() {
    this.smscode = this.value;
    this.getCaptcha();
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    async handleClick() {
      try {
        if (!this.REGEX.mobile.test(this.phone)) {
          return this.$toast('请输入正确的手机号');
        }
        if (this.captchaOpen) {
          const res = await this.captchaShow();
          await this.validateCaptcha(res);
        } else {
          if (!this.captcha.value) {
            return this.$toast('请输入图片验证码');
          }
          await this.validateCaptcha();
        }
      } catch (err) {
        // console.log(err);
      }
    },
    onCaptchaLoaded() {
      this.captcha.loaded = true;
      this.captcha.loading = false;
    },
    // 校验图片验证码
    async validateCaptcha({ ticket = '', randstr = '' } = { ticket: '', randstr: '' }) {
      this.captcha.verifying = true;
      try {
        let data = {
          text: this.captcha.value,
          code: this.captcha.code,
        };
        if (this.captchaOpen) {
          data = {
            ticket,
            randstr,
          }
        }
        const { captcha } = await this.$api.postCaptchaImage(data);
        this.getSmsCode(captcha);
      } catch (err) {
        this.$toast('请输入正确的图片验证码');
        this.getCaptcha();
      } finally {
        this.captcha.verifying = false;
      }
    },
    // 获取图片验证码
    async getCaptcha() {
      this.smscode = '';
      this.verified = false;
      this.captcha.image = '';
      this.captcha.value = '';
      this.captcha.loading = true; // 图片加载（loaded）完成才取消
      this.captcha.loaded = false;
      try {
        const { code, image } = await this.$api.getCaptchaImage();
        this.captcha.code = code;
        this.captcha.image = image;
      } catch (error) {
        this.$toast('获取图形验证码失败！');
      }
    },
    // 获取短信验证码
    async getSmsCode(captcha) {
      try {
        let params = {
          phone: this.phone,
          captcha,
        };
        if (this.codeType) {
          params.codeType = this.codeType;
        }
        await this.$api.getSmsCode(params);
        this.$toast('验证码已发送');
        this.visible = false;
        this.$refs.timerButton.start();
      } catch (err) {
        this.$toast(err.message);
        this.getCaptcha();
      }
    },
  },
};
</script>
